/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import auth from "@/auth/authService";
import apiendpoints from "@/../apiendpoints";

export default {
    isUserLoggedIn: () => {
        let isAuthenticated = false;
        isAuthenticated = auth.isAuthenticated();

        return (localStorage.getItem('userInfo') && isAuthenticated);
    },
    apiendpoints: apiendpoints,
    userRole: 'public',
    userInfo: null
}